module.exports = __webpack_public_path__ + "img/dry.65c50300.svg";